
import Vue from 'vue';
import Component from 'vue-class-component';
import NavBar from '../components/NavBar';
import Footer from '@/components/Footer.vue';
import { take } from 'rxjs/operators';
import TermsOfUseApi from '@/api/terms-of-use.api';
import { TermsOfUseModel } from '@/models/terms-of-use.model';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import { i18nModule } from '@/utils/store-acessor';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    NavBar,
    Footer
  },
  metaInfo() {
    return {
      title: 'Ikone'
    };
  },
})
class TermsOfUse extends Vue {
  @i18nModule.Getter('locale') selected!: LocaleSelectorType;

  termsOfUseText = '';
  loading?: boolean = true;
  response: TermsOfUseModel = new TermsOfUseModel();

  async mounted() {
    await new TermsOfUseApi()
      .getTermsOfUse()
      .pipe(take(1))
      .subscribe(response => {
        this.response = response;
        this.loading = false;
        if (this.selected.value === 'en') {
          this.termsOfUseText = `${response?.value?.en}`;
        } else {
          this.termsOfUseText = `${response?.value?.pt}`;
        }
      });
  }

  @Watch('selected')
  onLocaleSelected(v: LocaleSelectorType) {
    if (v.value === 'en') {
      this.termsOfUseText = `${this.response?.value?.en}`;
    } else {
      this.termsOfUseText = `${this.response?.value?.pt}`;
    }
  }
}

export default TermsOfUse;
